<template>
  <div class="header-pc-body" :class="$route.name !== 'home'? 'has-background-color' : ''">
    <img src="../assets/nav-pc/logo1.png" alt="">
    <div class="header-pc-nav">
      <ul>
        <template v-for="(item,index) in navList">
          <li
            @mouseover="mouseover(index)"
            @mouseleave="mouseleave(index)"
            :class="index === bannerIndex ? 'active' : ''"
            @click="goOtherPage(item,index)"
          >
            {{ item.name }}
            <img
              v-if="item.children && item.children.length > 0"
              :src="item.active || index === bannerIndex ? activeImg:defaultImg"
              alt=""
            >
            <div
              class="hover-box"
              v-if="item.children && item.children.length > 0 && item.showBox"
              @mouseover="mouseoverDetail(index)"
              @mouseleave="mouseleaveDetail(index)"
              :class="$route.name !== 'home'? 'top-20' : 'top-2'"
            >
              <ul :class="$route.name !== 'home'? 'has-background-color' : ''">
                <template
                  v-for="(citem,cindex) in item.children"
                >
                  <li @click.stop="goOtherDetailPage(citem,cindex)">{{ citem.name }}</li>
                </template>
              </ul>
            </div>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from  'vuex'

  export default {
    name: "HeaderPc",
    computed: {
      ...mapGetters([
        'bannerIndex'
      ])
    },
    data () {
      return {
        navList: [
          {
            name: '首页',
            path: 'index',
          },
          {
            name: '解决方案',
            active: false,
            showBox: false,
            children: [
              {name: '飞联网',path: 'internet',title:'solution'},
              {name: '飞联网旅客服务',path: 'traveler',title:'solution'},
              {name: '飞联网航空公司服务',path: 'airway',title:'solution'},
            ]
          },
          {
            name: '关于我们',
            active: false,
            showBox: false,
            children: [
              {name: '公司简介',path: 'company',title: 'company'},
              {name: '加入我们',path: 'jion',title: 'company'}
            ]
          },
          {
            name: '联系我们'
          }
        ],
        defaultImg: require('../assets/nav-pc/down.png'),
        activeImg: require('../assets/nav-pc/up.png'),
        nowIndex: 0,
        hasShadow: false
      }
    },
    methods: {
      mouseover (index) {
        if (this.navList[index].active === false) {
          this.navList[index].active = true;
          this.navList[index].showBox = true;
        }
      },
      mouseleave (index) {
        if (this.navList[index].active === true) {
          this.navList[index].active = false;
          this.navList[index].showBox = false;
        }
      },
      mouseoverDetail (index) {
        if (this.navList[index].active !== undefined) {
          this.navList[index].showBox = true;
        }
      },
      mouseleaveDetail (index) {
        if (this.navList[index].active !== undefined) {
          this.navList[index].showBox = false;
        }
      },
      goOtherPage (item,index) {
        this.$store.commit('SET_BANNER_INDEX', index);
        if (item.name === '首页' || item.name === '联系我们') {
          if (this.$route.name !== 'home') {
            this.$router.push('/')
          }
        }
      },
      goOtherDetailPage (item,index) {
        const { path,title } = item;
        if (title === 'solution') {
          let params = {
            path,
            index
          };
          this.$store.commit('SET_SOLUTION_PARAMS', params);
          this.$store.commit('SET_BANNER_INDEX', 1);
          if (this.$route.name === 'solution') return false;
          this.$router.push({name: 'solution'})
        } else {
          this.$store.commit('SET_COMPANY_INDEX',index);
          this.$store.commit('SET_BANNER_INDEX', 2);
          if (this.$route.name === 'company') return false;
          this.$router.push({name: 'company'});
        }
      }
    },
    mounted () {
      // console.log(this.$route)
    }
  }
</script>

<style scoped>
  .header-pc-body {
    width: 100%;
    height: 90px; /*no*/
    box-sizing: border-box;
    display: flex;
    align-items: center;
    /*padding: 0 40px; !*no*!*/
    padding: 0 100px 0 40px; /*no*/
    justify-content: space-between;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
  }

  .has-background-color{
    background: rgba(38, 45, 61, 0.6);
  }

  .header-pc-nav {
    height: 90px; /*no*/
    width: 532px; /*no*/
  }

  .header-pc-nav ul {
    width: 100%;
    height: 90px; /*no*/
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px; /*no*/
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 27px; /*no*/
  }

  .header-pc-nav ul li{
    cursor: pointer;
    letter-spacing: 1px;  /*no*/
    height: 100%;
    display: flex;
    align-items: center;
    /*padding: 14px 0; !*no*!*/
    box-sizing: border-box;
    border-bottom: 2px solid transparent; /*no*/
    position: relative;
    font-family:SourceHanSansCN-Regular,SourceHanSansCN;
  }
  .header-pc-nav ul li img{
    margin-left: 8px;
  }
  .header-pc-nav ul li:hover{
    color: #00D2DB;
  }
  .active{
    position: relative;
    color: #00D2DB;
  }
  .active:after{
    content: "";
    position: absolute;
    bottom: 16px; /*no*/
    left: 0;
    width: 100%;
    height: 2px; /*no*/
    background-color: #00D2DB;
  }
  .header-pc-nav ul li:hover .header-pc-nav ul li:after{
    display: block;
  }

  .hover-box {
    width: 160px; /*no*/
    position: absolute;
    left: -38%;
    bottom: 0;
  }

  .top-2{
    /*top: calc(100% - 18px); !*no*!*/
    top: calc(100% + 2px); /*no*/
  }
  .top-20{
    top: calc(100% + 2px); /*no*/
  }

  .hover-box ul{
    display: flex;
    flex-direction: column;
    justify-content: normal;
    height: auto;
    margin: 0; /*no*/
    padding: 0;
    padding-bottom: 5px;
  }
  .hover-box ul li{
    padding: 11px 0;  /*no*/
    /*padding: 0;*/
    font-size:16px; /*no*/
    box-sizing: border-box;
    font-weight:400;
    color:rgba(255,255,255,1);
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderPc.vue